"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

require("../../assets/css/components/notificacao/Dialog.css");

var _Card = require("../card/Card");

var _Card2 = _interopRequireDefault(_Card);

var _ButtonFields = require("../form/ButtonFields");

var _ButtonFields2 = _interopRequireDefault(_ButtonFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEY_TAB = 9;
var KEY_ENTER = 9;
var KEY_ESC = 27;

var Dialog = function (_React$Component) {
    _inherits(Dialog, _React$Component);

    function Dialog(props) {
        _classCallCheck(this, Dialog);

        var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));

        _this.onAgree = function () {
            if (_this.props.onAgree) _this.props.onAgree();
            _this.props.displayFunction(false);
        };

        _this.onCancel = function () {
            if (_this.props.onCancel) _this.props.onCancel();
            if (_this.props.fixedContent) _this.props.fixedContent(false);
            _this.props.displayFunction(false);
            _this.state.oldFocusedEl.focus();
        };

        _this.getActions = function () {
            return _this.props.onAgree ? [_react2.default.createElement(_ButtonFields2.default, { button: "flat", content: "Cancelar", onClick: _this.onCancel,
                color: "red", type: "button", ariaLabel: "Cancelar " }), _react2.default.createElement(_ButtonFields2.default, { button: "flat", content: "Ok", onClick: _this.onAgree, color: "green", type: "button",
                ariaLabel: "Ok" })] : _react2.default.createElement(_ButtonFields2.default, { button: "flat", content: "Fechar", onClick: _this.onCancel, color: "red", type: "button",
                ariaLabel: "Fechar " });
        };

        _this.state = {
            oldFocusedEl: null,
            displayFlex: true
        };
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.updateDimensions = _this.updateDimensions.bind(_this);
        return _this;
    }

    _createClass(Dialog, [{
        key: "onKeyDown",
        value: function onKeyDown(event) {
            var dialog = _reactDom2.default.findDOMNode(this);
            var focusableEls = dialog.querySelectorAll('a[href], area[href], input:not([disabled]), ' + 'select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
            switch (event.keyCode) {
                case KEY_TAB:
                    if (focusableEls.length === 1) {
                        event.preventDefault();
                        break;
                    }
                    if (event.shiftKey) {
                        if (document.activeElement === focusableEls[0]) {
                            focusableEls[focusableEls.length - 1].focus();
                            setTimeout(function () {
                                focusableEls[focusableEls.length - 1].focus();
                            }, 0);
                        }
                    } else {
                        if (document.activeElement === focusableEls[focusableEls.length - 1]) setTimeout(function () {
                            focusableEls[0].focus();
                        }, 0);
                    }
                    break;
                case KEY_ESC:
                    this.onCancel();
                    break;
                default:
                    break;
            }
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            this.setState({ oldFocusedEl: document.activeElement });
        }
    }, {
        key: "updateDimensions",
        value: function updateDimensions() {
            if (this.props.fixedContent) {
                if (_reactDom2.default.findDOMNode(this.dialog).scrollHeight > window.innerHeight) {
                    this.props.fixedContent(true);
                    this.setState({ displayFlex: false });
                } else {
                    this.props.fixedContent(false);
                    this.setState({ displayFlex: true });
                }
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.dialog.focus();
            window.addEventListener("resize", this.updateDimensions);
            this.updateDimensions();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                "div",
                { className: "flat-modal" + (!this.state.displayFlex ? "-not-flex" : ""), role: "dialog", "aria-label": "Teste", "aria-describedby": "dialog-description",
                    onKeyDown: this.onKeyDown, ref: function ref(dialog) {
                        _this2.dialog = dialog;
                    }, tabIndex: "0" },
                _react2.default.createElement(
                    _Card2.default,
                    { titulo: this.props.modalTitle, width: 6, actions: this.getActions(), className: "card-modal",
                        descricao: this.props.modalDescription, centered: true, borderBottom: true },
                    _react2.default.createElement(
                        "div",
                        { id: "dialog-description" },
                        this.props.children
                    )
                )
            );
        }
    }]);

    return Dialog;
}(_react2.default.Component);

exports.default = Dialog;


Dialog.propTypes = {
    modalTitle: _propTypes2.default.string,
    modalDescription: _propTypes2.default.string,
    onCancel: _propTypes2.default.func,
    onAgree: _propTypes2.default.func,
    displayFunction: _propTypes2.default.func,
    fixedContent: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/notificacao/Dialog.js
// module id = 1131
// module chunks = 0